import {
  GeniallyContext,
  TriggerContext,
  UserContext,
} from '@genially/snowplow-contracts';
import { CommonEventProperties, SelfDescribingEvent } from '@snowplow/browser-tracker';

import { mapAllContextsAsArray } from '../utils/mapAllContextsAsArray';

enum InteractiveQuestionSettingsPreset {
  Live = 'live',
  LeaderboardQuiz = 'leaderboardQuiz',
  Test = 'test',
  Survey = 'survey',
  Review = 'review',
  Gamification = 'gamification',
  Custom = 'custom',
}

enum InteractiveQuestionResponseAction {
  NOT_REPEAT = 'NOT_REPEAT',
  REPEAT_UNTIL_CORRECT = 'REPEAT_UNTIL_CORRECT',
  REPEAT_FINISH_GENIALLY = 'REPEAT_FINISH_GENIALLY',
}

export enum InteractiveQuestionSettingResultsSummary {
  NO_SHOW = 'NO_SHOW',
  INDIVIDUAL_SUMMARY = 'INDIVIDUAL_SUMMARY',
  GLOBAL_SUMMARY = 'GLOBAL_SUMMARY',
}

export const getInteractiveQuestionPresetSelectedEvent = ({
  genially,
  user,
  trigger,
  presetType,
  repeatQuestionMode,
  showResultsMode,
}: {
  genially?: GeniallyContext;
  user: UserContext;
  trigger?: TriggerContext;
  presetType: InteractiveQuestionSettingsPreset;
  repeatQuestionMode?: InteractiveQuestionResponseAction;
  showResultsMode?: InteractiveQuestionSettingResultsSummary;
}): SelfDescribingEvent & CommonEventProperties => ({
  event: {
    schema: 'iglu:com.genially/interactive_question_preset_selected/jsonschema/1-0-0',
    data: {
      preset_type: presetType,
      repeat_question_mode: repeatQuestionMode,
      show_results_mode: showResultsMode,
    },
  },
  context: mapAllContextsAsArray({ genially, user, trigger }),
});
